import { Tooltip } from 'antd';
import { navigate } from '@reach/router';
import moment from 'moment-timezone';
import { ReactNode } from 'react';

import { useUserTimezone } from 'store/user/selector.hooks';
import RouteConstants from 'utils/RouteConstants';
import { tNamespaced } from 'utils/i18nUtil';

const tn = tNamespaced('TimezoneTooltip');

interface TimezoneTooltipProps {
  children: ReactNode;
}

const TimezoneTooltip = ({ children }: TimezoneTooltipProps) => {
  const userTimezone = useUserTimezone();
  const displayTimezone = userTimezone || moment.tz.guess();

  const tooltipTitle = (
    <span>
      {tn('message', { timezone: displayTimezone, interpolation: { escapeValue: false } })}{' '}
      <a
        href={RouteConstants.PROFILE}
        onClick={(e) => {
          e.preventDefault();
          navigate(RouteConstants.PROFILE);
        }}
        style={{ color: '#fff', textDecoration: 'underline' }}>
        {tn('profile_settings')}
      </a>
    </span>
  );

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <span>{children}</span>
    </Tooltip>
  );
};

export default TimezoneTooltip;
